import { IContact } from "src/domain/entities"
import { contactListApi } from "../../api/contact/contactListApi"

type PayloadShape = Parameters<typeof contactListApi>[0]

export async function contactListService(payload: PayloadShape, token?: null | string) {
	const contact = await contactListApi(payload, token)
	return contact as NonNullable<IContact[]>
}
